module.exports = __webpack_public_path__ + "img/wf-finishing-position-21.3de11251.svg";